import * as React from 'react';
import { createSubcomponent, styled, getTheme, } from '@workday/canvas-kit-react/common';
import { space } from '@workday/canvas-kit-react/tokens';
import { Popup } from '@workday/canvas-kit-react/popup';
import { useModalCard, useModalModel } from './hooks';
const ResponsiveModalCard = styled(Popup.Card)(({ theme }) => {
    const { canvas: canvasTheme } = getTheme(theme);
    return {
        margin: space.xl,
        [canvasTheme.breakpoints.down('s')]: {
            margin: space.s,
            padding: space.s,
            borderRadius: space.m, // 24px border radius on smaller devices.
        },
    };
});
export const ModalCard = createSubcomponent('div')({
    displayName: 'Modal.Card',
    modelHook: useModalModel,
    elemPropsHook: useModalCard,
})((elemProps, Element) => {
    return React.createElement(ResponsiveModalCard, Object.assign({ as: Element, width: 440, borderWidth: 0, depth: 6 }, elemProps));
});
